import mobx, { observable, action, computed } from 'mobx';
import api from '../../api';
// import accountStore from '../accountStore';
// import appStore from '../appStore';

export default class Cards {

	store = null;
	@observable data = null;
	@observable isLoading = 0;
	@observable count = 100;
	@observable page = 0;
	@observable pages = [];
	@observable cards = {};
	@observable vc = 0;
	@observable id = 0;

	constructor(store) {
		this.store = store;
	}

	@action init(params) {
		this.store.isLoading = 0;
		this.vc = params.vc ? params.vc : 0;
		this.id = params.cardId ? params.cardId : 0;
		this.getData();
	}

	@action dispose() {
		this.id = 0;
		this.pages = [];
		this.page = 0;
		this.vc = 0;
	}

	@action getData(more){
		if (more) this.isLoading = 1;
		api.toto.getCards({id: this.id, vc: this.vc, page: this.page, count: this.count}).then(
			action( data => { 
				if (data.code == "OK") {
					if (more) {
						this.cards[this.page] = data.result.cards;
					} else {
						this.data = data.result;
						this.cards[this.page] = data.result.cards;
						this.generatePage();
					}
				}
			}))
      .catch(action(err => {
        this.store.setResult('SERVER_TEMPORARILY_DOWN');
      }))
      .finally(action(() => { 
      	if (more) { 
      		this.isLoading = 0;
      	} else {
      		this.store.isLoading = 1;
      	}
      }));
	}

	@action generatePage() {
		const maxPage = Math.ceil(this.data.count/this.count);
		for(let i = 0; i < maxPage; i++ ) {
			this.pages.push({i: i, load: i == 0 ? 1 : 0});
		}
	}

	@action selectPage(page) {
		if (this.page != page) {
			this.page = page;
			const i = this.pages.findIndex(item => item.i == page);
			if (!this.pages[i].load) {
				this.pages[i].load = 1;
				this.getData(1);
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/stores/totoStore/cards.js